import { Box } from '@mui/material'
import { CorporateAccountsTreeDataGrid } from 'components/TreeDataGrid/CorporateAccountsTreeDataGrid'
import { Page } from 'components/Page'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { ErrorIndicator } from 'components/Shared/ErrorIndicator'
import * as _ from 'lodash'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'
import { PageHeader } from 'components/Shared/PageHeader'
import { NoDataIndicator } from 'components/Shared/NoDataIndicator'
import { getLEIdsByPermission } from 'utils/permissions'
import { useSetMe } from 'stores/useMeQuery'

export const LocationsPage = () => {
  const currentCorporateAccountId =
    useCurrentCorporateAccountStore().currentCorporateAccountId
  const { passedMe } = useSetMe()
  const meQuery = passedMe

  // Get LE Ids for the permission the user has access to
  const leIdsByPermission: number[] = getLEIdsByPermission(
    meQuery.data,
    currentCorporateAccountId,
    'locationsPermission'
  )

  const corporateAccount = _.compact(
    meQuery?.data?.corporateAccounts?.filter(
      (ca) => ca.id === currentCorporateAccountId
    )
  )
  const organizations = _.compact(meQuery?.data?.organizations)

  const licensedEstablishments = meQuery.data?.licensedEstablishments?.filter(
    (le) => le.corporateAccountId === currentCorporateAccountId
  )

  // Filter data by permission
  const licensedEstablishmentsFiltered = licensedEstablishments?.filter((x) =>
    leIdsByPermission.includes(x.id)
  )

  const sortedLicensedEstablishments = licensedEstablishmentsFiltered
    ? [...licensedEstablishmentsFiltered]
    : []

  const licensedEstablishmentsToShow = _.compact(sortedLicensedEstablishments)

  return (
    <Page
      header={
        <Box>
          <PageHeader
            title="Locations"
            isSecondary={true}
            headerBgColor="white"
          />
        </Box>
      }
    >
      {meQuery.isPending && <ActivityIndicator />}
      {meQuery.isError && <ErrorIndicator />}
      {leIdsByPermission.length === 0 ? (
        <NoDataIndicator
          noImage
          noDataMessage="Your current permissions do not allow access to view locations. To obtain access, please contact your Account Manager for assistance."
        />
      ) : (
        <Box pt="30px">
          <CorporateAccountsTreeDataGrid
            corporateAccounts={corporateAccount}
            organizations={organizations}
            licensedEstablishments={licensedEstablishmentsToShow}
          />
        </Box>
      )}
    </Page>
  )
}
